import styled from 'styled-components';

export const SectorTabContainer = styled.div`
    position: relative;
`;
